var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 13,
    height: 16,
    rx: 2.5,
    stroke: "#B3BEC7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 13,
    height: 16,
    rx: 2.5,
    fill: "#485662",
    stroke: "#B3BEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.73d01ad54cdefc83a8a0d6bf5de7b2c8.svg";
export { ForwardRef as ReactComponent };